import { render, staticRenderFns } from "./MBatchesForDashboard.vue?vue&type=template&id=556a16cd&scoped=true&lang=pug&"
import script from "./MBatchesForDashboard.vue?vue&type=script&lang=js&"
export * from "./MBatchesForDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MBatchesForDashboard.vue?vue&type=style&index=0&id=556a16cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a16cd",
  null
  
)

export default component.exports